import { FC } from 'react';
import { Icon, TIconNames } from 'components/Base/Icon';
import ToolTip from 'components/Base/ToolTip';
import { getSpeciesDisplayInfo } from 'helpers/utils';

type TSpeciesInfoIconProps = {
  species: { id: string; value: string };
  size?: number;
};

const SpeciesInfoIcon: FC<TSpeciesInfoIconProps> = ({ species, size = 14 }) => {
  const { originalValue, showInfoIcon } = getSpeciesDisplayInfo(species);
  if (!showInfoIcon) return null;

  return (
    <ToolTip placement="top" title={originalValue}>
      <span className="pointer">
        <Icon icon={TIconNames.TOOLTIP} size={size} className="mb-1" />
      </span>
    </ToolTip>
  );
};

export default SpeciesInfoIcon;
